import React from 'react'
import Password_management from '../../../components/Password_management/Password_management'

const Password_managementForm = () => {
    return (
        <div>
            <Password_management />
        </div>
    )
}

export default Password_managementForm